import React, { useState, useEffect } from 'react'
import NestedList from 'components/common/Form/NestedList'
import { formatMessage } from 'lib/intl'
import { formatUnitsData } from '../Common/formatUnits'

function UnitFilter({ unitList, units, setUnits, savedUnitIds }) {
  const [data, setData] = useState([])

  useEffect(() => {
    setData(formatUnitsData(units, unitList, savedUnitIds))
  }, [
    JSON.stringify(unitList),
    JSON.stringify(units),
    JSON.stringify(savedUnitIds),
  ])

  return (
    <NestedList
      selectView
      data={data}
      setData={setUnits}
      inputLabel={formatMessage('units')}
    />
  )
}

export default UnitFilter
